<template>
  <div class="base-select-wrapper">
    <label v-if="label" :for="selectId" class="base-select__label">{{ label }}</label>
    <select
      :id="selectId"
      :value="modelValue"
      :disabled="disabled"
      class="base-select"
      @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <slot></slot>
    </select>
    <small v-if="hint" class="base-select__hint">{{ hint }}</small>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  modelValue: string | number;
  label?: string;
  placeholder?: string;
  hint?: string;
  disabled?: boolean;
}>();

defineEmits<{
  'update:modelValue': [value: string];
}>();

const selectId = computed(() => `select-${Math.random().toString(36).substr(2, 9)}`);
</script>

<style scoped>
.base-select-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.base-select__label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.base-select {
  width: 100%;
  padding: 0.65rem 0.75rem;
  border: 1px solid var(--color-border-light);
  border-radius: var(--radius-md);
  font-size: var(--font-size-md);
  font-family: var(--font-family);
  background: var(--color-bg-primary);
  transition: all var(--transition-base);
  cursor: pointer;
}

.base-select:focus {
  outline: none;
  border-color: var(--color-border-focus);
  box-shadow: var(--shadow-focus);
}

.base-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--color-bg-tertiary);
}

.base-select__hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}
</style>

